export default function PulseCircleCarousel({ className = "" }: { className?: string }) {
  return (
    <div
      className={`pulse-header-circle-carousel ${className}`.trim()}
      aria-hidden="true"
    >
      <div className="carousel-circle carousel-orange" />
      <div className="carousel-circle carousel-dark" />
      <div className="carousel-circle carousel-light" />
    </div>
  );
}
